module.exports = __webpack_public_path__ + "static/media/002-tongue-depressor-red.e88fa569.svg";